import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss']
})
export class BarComponent implements AfterViewInit {
  chartBar: any;
  showPanelProperties =  false; // propiedad permite visualizar sidebar
  showTableTmp: boolean = false; // propiedad permite visualizar la tabla
  @Input() showTable: boolean = false; // propiedad permite visualizar la tabla
  @Input() idElement = 'unknow';
  @Input() chartTitle = 'unknow';
  @Input() positionLegend: any =  {label: 'Arriba', code: 'top'}; // posicion de la leyenda
  @Input() AdditionalColorCard = "" ;


  

  cardMaximized = false; // indica el estado de la card del chart, Genenal
  positionLegendList = [
  {label: 'Arriba', code: 'top'},
  {label: 'Izquierda', code: 'left'},
  {label: 'Abajo', code: 'bottom'},
  {label: 'Derecha', code: 'right'}];
//////////////////////////// LINEAL
  @Input() typeLine: any = {label: 'Recta', code: 0 }; // Aplica a char LIneal
  typeLineList = [
    {label: 'Redondeada', code: 0.5},
    {label: 'Recta', code: 0}];

    fillTmp: boolean = false; // propiedad permite rellenar areas en char lineal
    @Input() fill: boolean = false; // propiedad permite rellenar areas en char lineal
//////////////////////////////////////////////
  @Input() typeChar: any = {label: 'Vertical', code: 'bar'}; // tipo basico de grafico
  typeCharList = [
    {label: 'Horizontal', code: 'horizontalBar'},
    {label: 'Vertical', code: 'bar'},
    {label: 'Radar', code: 'radar'},
    {label: 'Pie', code: 'pie'}, // funciona con un solo objeto en el dataset
   // {label: 'Polar Area', code: 'polarArea'}, ///  no es compatible con el esquema general 
    {label: 'Bubble', code: 'bubble'},
    // scatter  ///  no es compatible con el esquema general , los datos deben ir en pareja x, y  ejemplo -> {x: -10,y: 0 }
    {label: 'Lineal', code: 'line'}];

constructor() { console.log('construye obj')}

ngAfterViewInit(): void {
this.generateChart();
}

generateChart() {
this.chartBar = new Chart('canvas-bar', {
    type: this.typeChar.code,
    data: {
      labels: ["01-01", "02-01", "03-01", "04-01", "05-01", "06-01", "07-01","08-01", "09-01", "10-01", "11-01", "12-01", "13-01", "14-01"],
      datasets: [
          {
              label: "Semestre 1/2020",
              borderColor: 'blue',
              backgroundColor:  'rgba(0, 19, 192, 0.6)',
              lineTension: this.typeLine.code, /// aplica a grafica linea (redondeo de la linea)
              fill: false, /// aplica a grafica linea
              data: [28, 29, 32, 31, 31, 32, 42, 28, 28, 28, 29, 32, 32, 32]
          } ,
          {
            label: "Semestre 2/2020",
            borderColor: 'green',
            backgroundColor:  'rgba(41, 163, 41, 0.6)',
            lineTension: this.typeLine.code, /// aplica a grafica linea
            fill: false , /// aplica a grafica linea
            data: [26, 29, 31, 30, 28, 32, 32, 26, 29, 29, 29, 28, 32, 40]
        },
        {
          label: "Limite Min",
          borderColor: 'black',
          borderWidth: 0.5, // aplica a linea
          backgroundColor:  'rgba(0, 0, 0, 0.25)',
          lineTension: this.typeLine.code, /// aplica a grafica linea (redondeo de la linea)
          fill: this.fill, /// aplica a grafica linea
          data: [28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28]
      } ,
        {
          label: "Limite Max",
          borderColor: 'red',
          borderWidth: 0.5, // aplica a linea
          backgroundColor:  'rgba(204, 0, 0, 0.25)',
          lineTension: this.typeLine.code, /// aplica a grafica linea (redondeo de la linea)
          fill: this.fill, /// aplica a grafica linea
          data: [40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40]
      } ,
      ]
    },
    options: {
      legend: {
        display: true,
        position: this.positionLegend.code
      }
    }
    });
  }

  getStateCard(e) {
    this.cardMaximized = e;
  }

  onApplyChanges() {
    this.chartBar.destroy();
    this.fill = this.fillTmp;
    this.generateChart();
   // this.showPanelProperties = false;
  }

}
